import { cx } from '@linaria/core';
import { units } from '@ui/css';
import { props, verticalLineCls, horitzontalLineCls, chevronCls } from './styles.js';
export { selectors as chevronSelectors } from './styles.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Chevron({
  ref,
  className,
  vertical,
  inversed,
  size,
  lineWidth,
  color
}) {
  return /*#__PURE__*/jsxs("span", {
    ref: ref,
    className: cx(className, chevronCls, inversed && "inversed", vertical && "vertical"),
    style: props.__override({
      size: size !== undefined ? units.px(size) : undefined,
      pythagoreanSize: size !== undefined ? units.px(Math.sqrt(size ** 2 * 2)) : undefined,
      lineWidth: lineWidth !== undefined ? units.px(lineWidth) : undefined,
      lineColor: color
    }),
    children: [/*#__PURE__*/jsx("span", {
      className: cx(vertical ? verticalLineCls : horitzontalLineCls, "upper")
    }), /*#__PURE__*/jsx("span", {
      className: cx(vertical ? verticalLineCls : horitzontalLineCls, "lower")
    })]
  });
}

export { Chevron };
//# sourceMappingURL=chevron.js.map
